import { render, staticRenderFns } from "./DropdownProperties.vue?vue&type=template&id=006443c3&scoped=true&"
import script from "./DropdownProperties.vue?vue&type=script&lang=js&"
export * from "./DropdownProperties.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "006443c3",
  null
  
)

export default component.exports